import { SelectCheckedCircle, SelectUncheckedCircle } from 'components/Icons';
import React from 'react';
import { Button } from 'react-bootstrap';

const CoverComponent = ({ content, setSelected, isSelected }) => {
    const { id, color, image } = content;

    const setSelectedBound = () => {
        if (setSelected) {
            setSelected(id);
        }
    }

    return (
        < div
            className="profile-header d-flex align-items-end justify-content-end mb-2"
            style={{
                backgroundColor: color ? color : '#000',
                backgroundImage: image ? image : ''
            }}>

            <Button
                type="button"
                onClick={setSelectedBound}
                className="btn btn-light bg-transparent d-flex align-items-center  text-uppercase text-white  mr-3 mb-3"
                style={{ borderRadius: '32px', zIndex: 9 }}
            >
                {
                    isSelected ? <SelectCheckedCircle /> : <SelectUncheckedCircle />
                }

            </Button>
        </div >
    )
}

export default CoverComponent;
